module.exports = __webpack_public_path__ + "static/media/X1.98b5e6be.pdf";